import { Typography, TextField, Grid, Hidden, CircularProgress } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { useState } from 'react';
import { talentService } from 'shared/services/talentService';
import { useQueryClient } from 'react-query';
import { CustomTextField } from '../FieldContent/FieldContent.styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import SaveIcon from '@material-ui/icons/Save';
import { CONFIG } from 'shared/config';

const { updateMe } = talentService();

type EditFieldsProps = {
  talent_slug: string;
  isEditing: boolean;
  seIsEditing: Function;
  changeSlug: Function;
  talent_country_code: string;
};

const EditFields = ({ talent_slug, isEditing, seIsEditing, changeSlug, talent_country_code }: EditFieldsProps) => {
  const queryClient = useQueryClient();
  const [newSlug, setNewSlug] = useState(talent_slug);
  const [validate, setValidate] = useState('');
  const { mutate: updateMutate, isLoading } = updateMe();
  const handleEditClick = async () => {
    if (newSlug === '') return setValidate('This field is required');

    if (isEditing && newSlug) {
      updateMutate(
        {
          slug: newSlug,
        },
        {
          onSuccess: async () => {
            changeSlug(newSlug);
            seIsEditing((prev: boolean) => !prev);
            await queryClient.invalidateQueries(['me']);
          },
          onError: (error: any) => {
            if (error?.response?.status === 400) {
              setValidate('This name already exist!');
            } else {
              setValidate('Something went wrong while doing this action');
            }
          },
        },
      );
    }
    if (!isEditing) seIsEditing((prev: boolean) => !prev);
  };

  return (
    <Grid container>
      <Grid item xs={12} md={7}>
        <CustomTextField
          size="small"
          variant="outlined"
          value={`${CONFIG?.TALENT_APP_URL}/${talent_country_code?.toLowerCase() || 'not-available'}`}
          fullWidth
        />
      </Grid>
      <Hidden smDown>
        <Grid item xs={12} md={1} style={{ marginTop: '25px' }}>
          <Typography style={{ textAlign: 'center' }}>/</Typography>
        </Grid>
      </Hidden>
      <Hidden mdUp>
        <Grid item xs={12} md={1}>
          <Typography style={{ textAlign: 'center' }}>/</Typography>
        </Grid>
      </Hidden>
      <Grid item xs={12} md={4}>
        <CustomTextField
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isLoading ? (
                  <CircularProgress size={14} />
                ) : (
                  <SaveIcon
                    onClick={handleEditClick}
                    fontSize="small"
                    style={{ color: COLORS.PRIMARY, cursor: 'pointer' }}
                  />
                )}
              </InputAdornment>
            ),
          }}
          helperText={validate}
          variant="outlined"
          value={newSlug}
          onChange={(e) => setNewSlug(e.target.value)}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default EditFields;
